import { Paper, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { RedirectType } from "src/types/apps";

import Context from "../context";

export default function DialogPaper() {
	const { state } = useContext(Context);
	const queryClient = useQueryClient();

	const appSelected = queryClient.getQueryData<string>(["apps", "selected"]) ?? "";
	const redirects = queryClient.getQueryData<RedirectType[]>(["apps", "redirects", appSelected]);
	const url = redirects?.find((i) => i.id === state.uriActionId)?.redirectURI;

	return (
		<Paper elevation={3} sx={{ p: 3, mx: 3, mb: 3 }}>
			<Typography variant='body2'>{url}</Typography>
		</Paper>
	);
}
